import { Injectable } from "@angular/core";
import { RestaurantService } from './restaurant.service';
import { ApiService } from './api.service';
import { AuthenticationService } from './authentication.service';

@Injectable({
	providedIn: "root",
})
export class CashbackService {

	constructor(
        private apiService: ApiService,
        private restaurantService: RestaurantService,
        private authService: AuthenticationService,
    ) {}

    getClientID(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.authService.getUser().then(user => {
                resolve(user.id);
            }).catch(error => {
                reject(error);
            });
        });
    }

    // Visitante sem login: o `getClientID` rejeita com 'not logged'. Sem o `.catch(reject)`
    // a recusa ficava órfã (console.error em toda carga do cardápio, apontado pelo
    // PageSpeed) e esta promise nunca terminava, então o `.catch` de quem chama não rodava.
    getCashbackBalance(): Promise<any> {
		let restaurantID = this.restaurantService.restaurant.info.id;
		return new Promise((resolve, reject) => {

            this.getClientID().then(clientID => {
                this.apiService.get(`/restaurant/${restaurantID}/public/client/${clientID}/cashback/balance`).subscribe(response => {
                    resolve(response);
                }, error => {
                    reject(error);
                })
            }).catch(reject);
		})
    }

    getCashbackExtract(payload: any): Promise<any> {
		let restaurantID = this.restaurantService.restaurant.info.id;
		return new Promise((resolve, reject) => {

            this.getClientID().then(clientID => {
                this.apiService.post(`/restaurant/${restaurantID}/public/client/${clientID}/cashback/extract`, payload).subscribe(response => {
                    resolve(response);
                }, error => {
                    reject(error);
                })
            }).catch(reject);
		})
    }

}
